// extracted by mini-css-extract-plugin
export default {"root":"ShowSitePageContainer_root__84tIo","tabsContainer":"ShowSitePageContainer_tabsContainer__GYsV8"};